// @flow
import React from 'react'
import styled, { type StyledComponent } from 'styled-components'

const Link: StyledComponent<Object, any, any> = styled.a`
  font-size: 12px;
  text-decoration: none;
  display: inline-block;
  border-bottom: dashed 1px $link-color;
  margin: 6px 0 12px;
  padding-right: 20px;
`

type Props = {|
  label: string,
  onClick: Function
|}

export default function MatchedAction({ label, onClick }: Props) {
  return (
    <Link onClick={handleClick(onClick)} href="#">
      {label}
    </Link>
  )
}

function handleClick(action) {
  return (event) => {
    event.preventDefault()
    action()
  }
}
